export const githubUrl = 'https://github.com/E3-JSI/StreamStory2';
export const paperUrl = 'https://doi.org/10.1109/TVCG.2018.2825424';
